import { render, staticRenderFns } from "./Yuebao.vue?vue&type=template&id=43396408"
import script from "./Yuebao.vue?vue&type=script&lang=js"
export * from "./Yuebao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports